import React, { useEffect, useRef, useState } from 'react';
import {NumericFormat, NumberFormatBase,useNumericFormat, NumberFormatBaseProps} from 'react-number-format';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Translate from '../../utils/Translate';
import getUid from '../../utils/getUid';
import { INumberFieldProps } from '../MaterialUi/NumberField';
// import { withStyles } from '@mui/styles';
import { styled } from "@mui/material/styles";



const CssTextField = styled(TextField)(({ theme }) => ({
    '& label': {
        transform: 'none',
        position: 'absolute',
        top: "19px",
        left: "14px",
        [theme.breakpoints.down('sm')]: {
            fontSize: "0.95em",
            left: "4px",
        },
    },
    '& input': {
        paddingLeft: "80px",
        paddingRight: "14px",
        color: "rgba(0, 0, 0, 0.6)",
        [theme.breakpoints.down('sm')]: {
            fontSize: "0.95em",
            paddingLeft: "60px",
            paddingRight: "4px",
        },
    }
     
}));

/**
 * NumberField mit:
 * - feste stehendes Label links ausgerichtet
 * - "egal" als Suffix, wenn kein Wert
 * - suffix wird nur angezeigt, wenn Feld fokussiert ist oder Wert vorhanden
 */
const NumberField: React.FC<React.PropsWithChildren<INumberFieldProps>> = (props) => {
    
    const {
        id = null,
        name = '',
        value = '',
        onChange = () => { },
        thousandSeparator = '.',
        decimalSeparator = ',',
        decimalScale = 2,
        suffix,
        prefix,
        autoFocus = false,
        // allowEmptyFormatting = true,
        label = '',
        // className = '',
        error = false,
        helperText = '',
        fixedDecimalScale = false,
        // customInput,
        // inputProps,
        // ...other
    } = props;

    const {autocomplete, inputMode  = 'decimal', ...numberFormatProps} = props;
    
    const [uid] = useState(id ? id : getUid('numberfield' + name));

    const [isFocused, setIsFocused] = useState(false);


    const inputRef = useRef<HTMLInputElement>();


    // const currValue = typeof value === 'string' ? Translate.getNumber(parseFloat(value)) : Translate.getNumber(value);
    const currValue = `${value}`;

    const handleFocus = () => {
        // const elm = document.getElementById(uid) as HTMLInputElement;
        const elm = inputRef.current;
        elm.selectionStart = 0;
        elm.selectionEnd = Translate.getNumber(parseFloat(currValue))?.length || 0;
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);

    };

    const fontSize = name === 'priceTo' 
        ? currValue.length > 7 ? `${1+(7-currValue.length)/10}em` : '1em' 
        : currValue.length > 4 ? `${1+(4-currValue.length)/10}em` : '1em' 

    return (
        <CustomNumberFormat
            {...numberFormatProps}
            name={name}
            value={currValue || ''}
            customInput={CssTextField}
            label={label + ':'}
            fullWidth
            inputProps={{
                style: { textAlign: 'right', fontSize },
                inputMode: inputMode,
                autoComplete: autocomplete === false ? 'off' : typeof autocomplete === 'string' ? autocomplete : null,
            }}
            inputRef={inputRef}
            id={uid}
            decimalScale={decimalScale}
            fixedDecimalScale={fixedDecimalScale}
            // fixedDecimalScale={decimalScale && parseFloat(currValue) > 0 && Translate.parseInt(currValue) !== Translate.parseFloat(currValue)}
            onValueChange={(values) => {
                onChange(name, values.floatValue);
            }}
            onChange={undefined}
            displayType={'input'}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            disabled={false}
            suffix={isFocused ? suffix : currValue ? suffix : 'egal'}
            // suffix={suffix}
            prefix={prefix ? prefix : undefined}
            allowEmptyFormatting
            allowLeadingZeros={false}
            autoFocus={autoFocus}
            error={error}
            helperText={helperText}
            onFocus={handleFocus}
            onBlur={handleBlur}
             
        />
    );
};

// https://s-yadav.github.io/react-number-format/docs/customization/#allowemptyformatting-on-numericformat
export function CustomNumberFormat(props: NumberFormatBaseProps<any> & { allowEmptyFormatting?: boolean, suffix?: string, prefix?: string }) {
    const { prefix = "", suffix = "",  ...restProps } = props;
    const { format, allowEmptyFormatting, ...numberFormatBaseProps } = useNumericFormat(props);
    const _format = (numStr, props) => {
        // @ts-expect-error Expected 1 arguments, but got 2.
        const formattedValue = format(numStr, props );
        // console.debug(numStr, props, suffix,allowEmptyFormatting,formattedValue);
        return allowEmptyFormatting && (formattedValue === "" || formattedValue.endsWith('egal'))
            ? `${prefix ? prefix : ''}${suffix ? suffix : ''}`
            : formattedValue;
    };

    // @ts-expect-error Expected 1 arguments, but got 2.
    return <NumberFormatBase {...numberFormatBaseProps} format={_format} />;
}


export default NumberField;
